import { useTranslation } from "react-i18next";
import { ButtonConfirm } from "../../../../Layout/Buttons";
import styled from "styled-components";

const NoContactNotificationWrapper = styled.div`
  .button-wrapper {
    display: flex;
    justify-content: flex-end;
  }
`;

interface INoContactNotificationProps {
  practiceDate: string | undefined;
  onSend: () => void;
}

const NoContactNotification = (props: INoContactNotificationProps) => {
  const { practiceDate, onSend } = props;

  const { t } = useTranslation();

  return (
    <NoContactNotificationWrapper>
      <div>
        {/* L'invio automatico, se previsto per questa pratica, partirà il:{" "}
        {autoNotificationDate} */}
        {t("MESSAGES.auto-notification-pec-sender")}
      </div>

      <div className="button-wrapper">
        <ButtonConfirm onClick={() => onSend()}>
          {t("button-manual-sending")!}
        </ButtonConfirm>
      </div>
    </NoContactNotificationWrapper>
  );
};

export default NoContactNotification;
